import {
  CREATE_USER, CREATE_USER_SUCCESS, CREATE_USER_FAILURE,
  AUTHENTICATE_USER, AUTHENTICATE_USER_SUCCESS, AUTHENTICATE_USER_FAILURE,
  RESET_TOKEN, RESET_SIGNIN,
  LOGOUT_USER, SIGNIN_USER, SIGNIN_USER_SUCCESS, SIGNIN_USER_FAILURE
} from '../actions/users'

const INITIAL_STATE = {user: null, status: null, error: null, loading: false}

const users = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case CREATE_USER:
      return { ...state,
        user: null, status:'signup', error: null, loading: true
      }
    case CREATE_USER_SUCCESS:
      return { ...state,
        user: action.payload.user, status: 'authenticated', error: null, loading: false
      }
    case CREATE_USER_FAILURE:
      return { ...state,
        user: null, status: 'signup', error: action.payload, loading: false
      }

    case AUTHENTICATE_USER:
      return { ...state,
        user: null, status: 'storage', error: null, loading: true
      }
    case AUTHENTICATE_USER_SUCCESS:
      return { ...state,
        user: action.payload.user, status: 'authenticated', error: null, loading: false
      }
    case AUTHENTICATE_USER_FAILURE:
      return { ...state,
        user: null, status: 'storage', error: action.payload, loading: false
      }

    case RESET_TOKEN:
      return { ...state,
        user: null, status: 'storage', error: null, loading: false
      }

    case RESET_SIGNIN:
      return { ...state,
          error: null, loading: false
      }

    case LOGOUT_USER:
      return { ...state,
        user: null, status:'logout', error: null, loading: false
      }

    case SIGNIN_USER:
      return { ...state,
        user: null, status: 'signin', error: null, loading: true
      }
    case SIGNIN_USER_SUCCESS:
      return { ...state,
        user: action.payload.user, status: 'authenticated', error: null, loading: false
      }
    case SIGNIN_USER_FAILURE:
      return { ...state,
        user: null, status: 'signin', error: action.payload, loading: false
      }

    default:
      return state
  }
}

export default users



// WEBPACK FOOTER //
// ./src/reducers/Users.js